export enum Companies {
  Admin = 'admin',
}
